<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.2583 6.40164C9.2583 5.98743 9.59409 5.65164 10.0083 5.65164H16.5083C16.9225 5.65164 17.2583 5.98743 17.2583 6.40164C17.2583 6.81586 16.9225 7.15164 16.5083 7.15164H10.0083C9.59409 7.15164 9.2583 6.81586 9.2583 6.40164Z"
      fill="currentColor"
    />
    <path
      d="M9.2583 13.4016C9.2583 12.9874 9.59409 12.6516 10.0083 12.6516H16.5083C16.9225 12.6516 17.2583 12.9874 17.2583 13.4016C17.2583 13.8159 16.9225 14.1516 16.5083 14.1516H10.0083C9.59409 14.1516 9.2583 13.8159 9.2583 13.4016Z"
      fill="currentColor"
    />
    <path
      d="M4.6887 7.90164V4.08346H5.74765V7.90164H4.6887ZM5.22066 3.59128C5.06323 3.59128 4.92816 3.53907 4.81547 3.43467C4.70444 3.32861 4.64893 3.20183 4.64893 3.05434C4.64893 2.90851 4.70444 2.78339 4.81547 2.67899C4.92816 2.57293 5.06323 2.5199 5.22066 2.5199C5.37809 2.5199 5.51233 2.57293 5.62336 2.67899C5.73605 2.78339 5.79239 2.90851 5.79239 3.05434C5.79239 3.20183 5.73605 3.32861 5.62336 3.43467C5.51233 3.53907 5.37809 3.59128 5.22066 3.59128Z"
      fill="currentColor"
    />
    <path
      d="M7.23975 7.96628C7.07568 7.96628 6.93482 7.90827 6.81716 7.79227C6.70116 7.67461 6.64316 7.53375 6.64316 7.36968C6.64316 7.20728 6.70116 7.06807 6.81716 6.95207C6.93482 6.83607 7.07568 6.77807 7.23975 6.77807C7.39884 6.77807 7.53804 6.83607 7.65736 6.95207C7.77668 7.06807 7.83634 7.20728 7.83634 7.36968C7.83634 7.47906 7.80816 7.57932 7.75182 7.67047C7.69713 7.75995 7.62504 7.83204 7.53556 7.88673C7.44607 7.93976 7.34746 7.96628 7.23975 7.96628Z"
      fill="currentColor"
    />
    <path
      d="M2.78147 15.9016V12.0835H3.84042V15.9016H2.78147ZM3.31343 11.5913C3.156 11.5913 3.02094 11.5391 2.90825 11.4347C2.79722 11.3286 2.7417 11.2018 2.7417 11.0543C2.7417 10.9085 2.79722 10.7834 2.90825 10.679C3.02094 10.5729 3.156 10.5199 3.31343 10.5199C3.47087 10.5199 3.6051 10.5729 3.71613 10.679C3.82882 10.7834 3.88517 10.9085 3.88517 11.0543C3.88517 11.2018 3.82882 11.3286 3.71613 11.4347C3.6051 11.5391 3.47087 11.5913 3.31343 11.5913Z"
      fill="currentColor"
    />
    <path
      d="M4.6887 15.9016V12.0835H5.74765V15.9016H4.6887ZM5.22066 11.5913C5.06323 11.5913 4.92816 11.5391 4.81547 11.4347C4.70444 11.3286 4.64893 11.2018 4.64893 11.0543C4.64893 10.9085 4.70444 10.7834 4.81547 10.679C4.92816 10.5729 5.06323 10.5199 5.22066 10.5199C5.37809 10.5199 5.51233 10.5729 5.62336 10.679C5.73605 10.7834 5.79239 10.9085 5.79239 11.0543C5.79239 11.2018 5.73605 11.3286 5.62336 11.4347C5.51233 11.5391 5.37809 11.5913 5.22066 11.5913Z"
      fill="currentColor"
    />
    <path
      d="M7.23975 15.9663C7.07568 15.9663 6.93482 15.9083 6.81716 15.7923C6.70116 15.6746 6.64316 15.5337 6.64316 15.3697C6.64316 15.2073 6.70116 15.0681 6.81716 14.9521C6.93482 14.8361 7.07568 14.7781 7.23975 14.7781C7.39884 14.7781 7.53804 14.8361 7.65736 14.9521C7.77668 15.0681 7.83634 15.2073 7.83634 15.3697C7.83634 15.4791 7.80816 15.5793 7.75182 15.6705C7.69713 15.76 7.62504 15.832 7.53556 15.8867C7.44607 15.9398 7.34746 15.9663 7.23975 15.9663Z"
      fill="currentColor"
    />
  </svg>
</template>
